var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCallDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.025 51.9874L47.106 59.3796C37.9401 53.9934 30.3007 46.3567 24.9113 37.1927L32.31 31.2737C33.177 30.5795 33.7898 29.6176 34.0525 28.5384C34.3153 27.4591 34.2133 26.3233 33.7625 25.3081L27.0187 10.1217C26.5351 9.03226 25.6803 8.14996 24.6067 7.63216C23.5331 7.11435 22.3105 6.9947 21.1568 7.29453L8.31778 10.6249C7.12005 10.938 6.07873 11.6795 5.39109 12.7089C4.70345 13.7383 4.41724 14.9842 4.58667 16.2105C6.83951 32.2547 14.2545 47.1292 25.7107 58.5854C37.1669 70.0416 52.0414 77.4566 68.0856 79.7094C69.3119 79.8789 70.5578 79.5927 71.5872 78.905C72.6166 78.2174 73.3581 77.1761 73.6712 75.9783L77.0016 63.1393C77.3007 61.9858 77.1808 60.7636 76.6634 59.6902C76.1459 58.6168 75.2644 57.7618 74.1757 57.2774L58.9906 50.5336C57.9754 50.0823 56.8392 49.9801 55.7598 50.2431C54.6804 50.5062 53.7186 51.1196 53.025 51.9874Z",
    stroke: "url(#paint0_linear_218_4635)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1953 14.9141V25.2891",
    stroke: "url(#paint1_linear_218_4635)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0078 20.1016H69.3828",
    stroke: "url(#paint2_linear_218_4635)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1953 4.5391C61.5738 4.53455 58.9937 5.19347 56.6954 6.4545C54.3971 7.71554 52.4553 9.53767 51.0508 11.7512C49.6463 13.9648 48.8248 16.4977 48.6628 19.1143C48.5008 21.7308 49.0035 24.3458 50.1242 26.7157L48.6328 35.6641L57.5813 34.1727C59.692 35.1699 62.0001 35.6795 64.3346 35.6637C66.6691 35.6479 68.9701 35.1071 71.0671 34.0813C73.1642 33.0556 75.0037 31.5711 76.4492 29.738C77.8948 27.9049 78.9094 25.7701 79.4179 23.4916C79.9265 21.2132 79.9159 18.8495 79.387 16.5757C78.8581 14.3019 77.8244 12.1762 76.3625 10.3561C74.9006 8.536 73.0479 7.06811 70.9417 6.06117C68.8356 5.05422 66.5298 4.53402 64.1953 4.5391Z",
    stroke: "url(#paint3_linear_218_4635)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_4635",
    x1: 95.1521,
    y1: 79.7529,
    x2: 7.87042,
    y2: 79.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_4635",
    x1: 65.443,
    y1: 25.2885,
    x2: 64.2412,
    y2: 25.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_4635",
    x1: 71.9528,
    y1: 21.1015,
    x2: 59.4837,
    y2: 21.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_4635",
    x1: 87.5099,
    y1: 35.6623,
    x2: 50.0621,
    y2: 35.6623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallDoctor);
export default __webpack_public_path__ + "static/media/ic-call-doctor.e0532a34e6093095880be1b70a474a3b.svg";
export { ForwardRef as ReactComponent };